import React from 'react';
import '../styles/MainButton.css';

// Props du composant MainButton
interface MainButtonProps {
    text: string;
    backgroundColor?: string;
    onClick?: () => void;
    disabled?: boolean;
    hasAnIcon?: boolean;
    iconSrc?: string;
}

// Composant pour un bouton principal avec styles personnalisés

const MainButton: React.FC<MainButtonProps> = ({
    text,
    backgroundColor = 'tertiary',
    onClick,
    disabled,
    hasAnIcon,
    iconSrc,
}) => {
    return (
        <div className='main-button-container'>
            <button
                className={`main-button main-button-${backgroundColor} ${
                    disabled ? 'main-button-disabled' : ''
                }`}
                onClick={onClick}
                disabled={disabled}
            >
                {text}
                {hasAnIcon && iconSrc && (
                    <img
                        src={iconSrc}
                        alt='icon'
                        className='main-button-icon '
                    />
                )}
            </button>
            <div
                className={`button-shadow ${
                    backgroundColor === 'secondary' ? 'button-shadow-alternate' : ''
                }`}
            ></div>
        </div>
    );
};

export default MainButton;
